import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ComponentPageTitle from '../../../components/PageTitle';
import CenteredContainer from '../../../components/CenteredContainer';
import PageName from '../../../components/PageName';
import Spacer from '../../../components/Spacer';

import { workData } from '../WorkData';
import ProductPageH2 from '../mini_components/ComponentProductPageH2';
import OfficeDx1 from '../../../assets/images/product_pages/office-dx/office-dx_1.png';
import OfficeDx2 from '../../../assets/images/product_pages/office-dx/office-dx_2.png';
import OfficeDx3 from '../../../assets/images/product_pages/office-dx/office-dx_3.png';
import OfficeDx4 from '../../../assets/images/product_pages/office-dx/office-dx_4.png';
import OfficeDx5 from '../../../assets/images/product_pages/office-dx/office-dx_5.png';
import OfficeDx6 from '../../../assets/images/product_pages/office-dx/office-dx_6.png';
import OfficeDx7 from '../../../assets/images/product_pages/office-dx/office-dx_7.png';
import OfficeDx8 from '../../../assets/images/product_pages/office-dx/office-dx_8.png';
import OfficeDx9 from '../../../assets/images/product_pages/office-dx/office-dx_9.png';
import OfficeDx10 from '../../../assets/images/product_pages/office-dx/office-dx_10.png';
import OfficeDx11 from '../../../assets/images/product_pages/office-dx/office-dx_11.png';
import OfficeDx12 from '../../../assets/images/product_pages/office-dx/office-dx_12.png';
import OfficeDx13 from '../../../assets/images/product_pages/office-dx/office-dx_13.png';
import CircleNum from '../mini_components/CircleNum';

import ComponentProductHeader from '../mini_components/ComponentProductHeader';
import ComponentSnsTile from '../../Profile/ComponentSnsTile';



const ProductOfficeDx = () => {
    const sushiwariData = workData.find(item => item.title === "事務DXアプリ");
    const [isDesktop, setIsMobile] = useState(window.innerWidth > 767);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth > 767);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    PageName("事務DXアプリ - 制作物");

    return (<>
        <Header />
        <CenteredContainer>
        <ComponentPageTitle title="事務DXアプリ - 制作物" />

        {/* ================================================= 冒頭部分 ================================================= */}
        <ComponentProductHeader isDesktop={isDesktop} data={sushiwariData} />
        {/* ========================================================================================================== */}


        {/* ============================================== 解決したい課題 =============================================== */}
        <ProductPageH2>解決したい課題</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>現在在学している高専の事務室に存在する、次の2つの課題を解決するために開発：</p>
            <Spacer height={20} />
            <ol style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                padding: 0,
                margin: 0
            }}>
                {/* 1つ目の項目 */}
                <li style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginRight: '50px',
                    textAlign: 'center'
                }}>
                    <p><CircleNum>1</CircleNum>各申請書が窓口前のボックスでしか入手できない</p>
                    <img src={OfficeDx1} alt="課題1" style={{ width: '100%', maxWidth: '380px', margin: '10px 0' }} />
                </li>

                {/* 2つ目の項目 */}
                <li style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                }}>
                    <p><CircleNum>2</CircleNum>窓口での学生からの質問対応が非効率である</p>
                    <img src={OfficeDx2} alt="課題2" style={{ width: '100%', maxWidth: '380px', marginTop: '60px' }} />
                </li>
            </ol>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 機能 =================================================== */}
        <ProductPageH2>機能</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>次の3つの機能によって、前述した2つの課題を解決し、学生・職員の双方が快適な生活を過ごせるようサポートします。</p>

            <Spacer height={20} />
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>書類の電子化　</span>管理者が書類のPDFデータを掲載し、学生がそれらをダウンロードできる
                <p style={{ marginLeft: '80px' }}>
                    <img src={OfficeDx3} alt="機能1" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>Q&Aの電子化　</span>管理者がQ&Aを掲載し、学生がそれらを閲覧できる
                <p style={{ marginLeft: '80px' }}>
                    <img src={OfficeDx4} alt="機能2" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>3</CircleNum><span style={{fontWeight: 'bold'}}>チャット　</span>書類とQ&Aの情報を元にあいまい検索を裏で実行し、チャット形式でユーザーが質問できる
                <p style={{ marginLeft: '80px' }}>
                    <img src={OfficeDx5} alt="機能2" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>4</CircleNum><span style={{fontWeight: 'bold'}}>検索　</span>現在公開されている書類とQ&Aを検索できる
                <p style={{ marginLeft: '80px' }}>
                    <img src={OfficeDx13} alt="機能13" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>5</CircleNum><span style={{fontWeight: 'bold'}}>管理者管理　</span>管理者は、掲載する書類とQ&Aを管理できる
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <img src={OfficeDx10} alt="機能10" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                    <img src={OfficeDx11} alt="機能11" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                    <img src={OfficeDx12} alt="機能12" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 裏機能 ================================================== */}
        <ProductPageH2>ユーザーの使いやすさのために工夫した点</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>前述した5つの機能に加え、次の2つの機能を搭載し、ユーザーの使いやすさのために工夫しました。</p>

            <Spacer height={20} />
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>学校名非表示　</span>電車内などでの使用時に他人に知られないよう、学校名を非表示にすることができます
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <img src={OfficeDx6} alt="機能6" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                    <img src={OfficeDx7} alt="機能7" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>チャット機能での遊び心　</span>チャットでは、単なるチャットボットではなく、学生が少しだけ楽しく使用できるよう、遊び心を持たせました。
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <img src={OfficeDx8} alt="機能8" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                    <img src={OfficeDx9} alt="機能9" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                </p>
            </p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================ デモページ ================================================ */}
        <ProductPageH2>デモページ</ProductPageH2>
        <ul>
            <p>次のリンクより、本アプリを体験することができます。</p>
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '30px' }}>
                <ComponentSnsTile
                    icon="link"
                    title="デモページ"
                    subtitle= "(⚠️表示までに時間がかかる場合あり)"
                    url= "https://office-dx-ad8a3.web.app/"
                    isSubtitleColumn={true}
                    isMiniSize={true}
                />
            </div>
        </ul>
        {/* ========================================================================================================== */}


        </CenteredContainer>
        <Footer />
    </>);
};



export default ProductOfficeDx;